
class gameMachineComponent extends SlotGame.src.component.BaseComponent {
    onGameReady() {
        super.onGameReady();

        // game.on(BonusGameComponent.events.START_OUTRO_TRANSITION, this.setParentGroupForLogo.bind(this, 'OVERLAY', 50))
        // game.on(BonusGameComponent.events.END_OUTRO_TRANSITION, this.setParentGroupForLogo.bind(this))
    }

    protected setParentGroupForLogo(parentGroup: string = 'GAME' , zOrder: number = 5): void{
        const gameLogo = game.tree.findByName('logo_container');
        this.setParentGroup(gameLogo, parentGroup);
        this.setZOrder(gameLogo, zOrder);

        this.onChangeOrientation();
    }

    setZOrder(obj, zOrder) {
        obj.zOrder = zOrder;
    }

    setParentGroup(obj, parentGroupName) {
        obj.parentGroup = game.render.layerGroups[parentGroupName];
    }

    getFSMHandlers(): any {
        return {
            ...super.getFSMHandlers(),
            GAMBLE: {
                ...super.getFSMHandlers()['GAMBLE'],
                open: {
                    on: this.setParentGroupForLogo.bind(this, 'OVERLAY', 50)
                },
            },
            IDLE: {
                ...super.getFSMHandlers()['IDLE'],
                enter: {
                    on: this.setParentGroupForLogo.bind(this)
                }
            },
        }
    }
}

//@ts-ignore
Game.src.component.gameMachineComponent = gameMachineComponent;
